import { Classification, LocalizedString } from '@synergy/models';
import { fields } from '@synergy/utils';

export interface TopicFormikValues {
    title: LocalizedString;
    description: LocalizedString;
    classifications: Classification[];
}

export const topicFormValuesFieldNames = fields<TopicFormikValues>();
